import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ProductReveal() {
  const modules = [{
    color: 'border-mod-1',
    emoji: '🔴',
    title: 'MÓDULO 1: LA DESPROGRAMACIÓN',
    description: 'Entendé por qué lo que te enseñaron no funciona. Limpieza de hábitos que te hacen ver invisible.'
  }, {
    color: 'border-mod-2',
    emoji: '🟠',
    title: 'MÓDULO 2: ARQUITECTURA DEL FLUJO',
    description: 'Cómo crear el escenario donde ella se sienta segura para avanzar. Sin presiones, sin libretos.'
  }, {
    color: 'border-mod-3',
    emoji: '🟢',
    title: 'MÓDULO 3: PSICOLOGÍA DEL IMÁN',
    description: 'La configuración mental para que dejes de ser un cazador y te conviertas en el destino.'
  }];
  const features = ['Video explicativo paso a paso', 'Guía de aplicación inmediata', 'Casos reales comentados', 'Ejercicios concretos para esa semana', 'Los errores más comunes y cómo evitarlos', 'Framework de conversación probado', 'Adaptado al hombre argentino real', 'Resultados aplicables desde el día 1'];
  return <section className="py-24 md:py-32 px-4 bg-bg-primary" data-id="element-198">
      <div className="max-w-6xl mx-auto" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-200">
          <div className="inline-block bg-bg-card border border-border-subtle rounded-full px-4 py-2 mb-6" data-id="element-201">
            <span className="text-sm font-semibold text-text-gold" data-id="element-202">
              🏆 EFECTO IMÁN™
            </span>
          </div>
          <h2 className="text-text-primary font-display font-bold text-3xl md:text-5xl mb-4" data-id="element-203">
            3 Módulos + 5 Bonos —{' '}
            <span className="text-text-gold" data-id="element-204">Sistema Completo</span>
          </h2>
          <div className="w-12 h-[3px] bg-gold-primary rounded-sm mx-auto mb-4" data-id="element-205" />
          <p className="text-text-secondary text-lg" data-id="element-206">Todo resuelto.</p>
        </motion.div>

        {/* Module Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-207">
          {modules.map((module, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-bg-card border-l-[4px] ${module.color} rounded-r-xl p-8`} data-id="element-208">
              <div className="text-text-gold text-[11px] font-bold uppercase mb-2" data-id="element-209">
                Módulo {i + 1}
              </div>
              <h3 className="text-text-primary font-bold text-xl mb-4 leading-snug" data-id="element-210">
                {module.title}
              </h3>
              <p className="text-text-secondary leading-relaxed text-base" data-id="element-211">
                {module.description}
              </p>
            </motion.div>)}
        </div>

        {/* Features Checklist */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-bg-card border border-border-subtle rounded-xl p-8 md:p-10 max-w-4xl mx-auto" data-id="element-212">
          <h3 className="text-text-primary font-bold text-2xl mb-8 border-l-[3px] border-gold-primary pl-4" data-id="element-213">
            Cada módulo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-214">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-215">
                <Check className="text-gold-primary flex-shrink-0 mt-1" size={20} data-id="element-216" />
                <span className="text-text-secondary text-base" data-id="element-217">{feature}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}